const initialState = {
  usageTracking: [],
  usageMetrics: [],
  responseHeaders: ''
};

const ApiStatisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_USAGE_TRACKING':
      return {
        ...state,
        usageTracking: action.payload,
        responseHeaders: action.headers,
        errorMsg: action.errorMsg
      };
    case 'GET_USAGE_METRICS':
      return {
        ...state,
        usageMetrics: action.payload
      };
    default:
      return state;
  }
};

export default ApiStatisticsReducer;
